import { LogFiltersType } from '@shared/services/logs/logs.service';
import { Feature } from 'config/feature-flags';

export enum FilterType {
  SINGLE_INPUT = 'singleInput',
  MULTI_IN_NOTIN = 'multipleInNotIn',
  INTERVAL = 'interval',
  SINGLE_SELECT = 'singleSelect',
}

export enum FiltersEnum {
  IP = 'ip',
  USER_AGENT = 'userAgent',
  STATUS_CODE = 'statusCode',
  ACTION = 'action',
  CAUSE = 'cause',
  COUNTRY = 'country',
  PATH = 'path',
  PATH_STARTS_WITH = 'path.startsWith',
  RESPONSE_TIME_GTE = 'responseTime.gte',
  CONTENT_LENGTH_GTE = 'contentLength.gte',
  CACHE_STATUS = 'cacheStatus',
  METHOD = 'method',
  ATTACK_CATEGORY = 'attackCategory',
  CREDIBILITY_BETWEEN = 'credibility',
  BOT_UA = 'botUA',
}

export const Filters: string[] = Object.values(FiltersEnum);

export interface FilterDefinition {
  key: FiltersEnum;
  slug: string;
  type: FilterType;
  tooltip?: string;
  choices?: Array<Choice>;
  visibleChoices?: Array<Choice>;
  canAddChoice?: boolean;
  suffix?: string;
  feature?: Feature;
  factor?: number;
  largeDropDown?: boolean;
}

type Choice = {
  slug: string;
  value: any;
};

export const initData: { [key in FilterType]: FilterData } = {
  [FilterType.INTERVAL]: { gte: 0, lte: 0 },
  [FilterType.MULTI_IN_NOTIN]: { in: [], notIn: [] },
  [FilterType.SINGLE_INPUT]: 0,
  [FilterType.SINGLE_SELECT]: null,
};

export interface FilterDataInNotIn {
  [LogFiltersType.IN];
  [LogFiltersType.NOTIN];
}

export interface FilterDataLteGte {
  [LogFiltersType.LTE];
  [LogFiltersType.GTE];
}

type FilterData = FilterDataInNotIn | FilterDataLteGte | number | string | boolean | null;

export type Filter = {
  active: boolean;
  data: FilterData;
  filterDefinition: FilterDefinition;
};

export type FilterDefinitions = { [key in FiltersEnum]: FilterDefinition };

export type Filters = Map<FiltersEnum, Filter>;

export function formatFiltersLogs(filters: Filter[]): { [prop: string]: any } {
  const data = {};

  filters.forEach((f) => {
    const key = f.filterDefinition.key;
    if (f.filterDefinition.type == FilterType.MULTI_IN_NOTIN) {
      if (key == FiltersEnum.PATH_STARTS_WITH) {
        // because laurent didn't want pathStartsWith.in and pathStartsWith.notIn
        data['path.startWith'] = f.data[LogFiltersType.IN].map((d) => d.value);
        data['path.notStartWith'] = f.data[LogFiltersType.NOTIN].map((d) => d.value);
        return;
      }
      data[`${key}.${LogFiltersType.IN}`] = f.data[LogFiltersType.IN].map((d) => d.value);
      data[`${key}.${LogFiltersType.NOTIN}`] = f.data[LogFiltersType.NOTIN].map((d) => d.value);
    } else if (f.filterDefinition.type == FilterType.INTERVAL) {
      data[`${key}.${LogFiltersType.GTE}`] = f.data[LogFiltersType.GTE] * (f.filterDefinition.factor || 1);
      data[`${key}.${LogFiltersType.LTE}`] = f.data[LogFiltersType.LTE] * (f.filterDefinition.factor || 1);
    } else if (f.filterDefinition.type == FilterType.SINGLE_INPUT) {
      data[key] = f.data;
    } else if (f.filterDefinition.type == FilterType.SINGLE_SELECT) {
      data[key] = f.data;
    }
  });

  return data;
}
